/**
 * MSAL-Konfiguration aus `import.meta.env.VITE_ENTRA_*` (Vorlage: app/.env.example).
 * Muster aus Axis (apps/web/src/auth/msalConfig.ts dort).
 *
 * Bewusst als Funktionen statt beim Import berechneter Konstanten: eine fehlende
 * Konfiguration soll erst beim Login auffallen, nicht schon beim Import (z. B. in Tests).
 */
import type { Configuration } from '@azure/msal-browser';

function pflichtwert(
  name: 'VITE_ENTRA_CLIENT_ID' | 'VITE_ENTRA_TENANT_ID' | 'VITE_ENTRA_API_SCOPE',
): string {
  const wert = import.meta.env[name];
  if (!wert)
    throw new Error(
      `${name} fehlt – app/.env.production.local bzw. .env.local anlegen (Vorlage .env.example).`,
    );
  return wert;
}

/** `redirectUri = window.location.origin`: dieselbe Konfiguration lokal und auf der SWA. */
export function msalKonfiguration(): Configuration {
  return {
    auth: {
      clientId: pflichtwert('VITE_ENTRA_CLIENT_ID'),
      authority: `https://login.microsoftonline.com/${pflichtwert('VITE_ENTRA_TENANT_ID')}`,
      redirectUri: window.location.origin,
    },
    cache: {
      // überlebt den Redirect-Rücksprung auch bei Tab-Wechsel (MSAL-Empfehlung)
      cacheLocation: 'localStorage',
    },
    system: {
      // Wie bei Axis: im Firmennetz reicht der Standard (10 s) für die stille Erneuerung nicht.
      iframeBridgeTimeout: 30_000,
    },
  };
}

let anmeldeAnfrage: { scopes: string[] } | undefined;

/** Scope für unsere API – stabiles Objekt (sonst löst MsalAuthenticationTemplate erneut aus). */
export function anmeldeAnfrageFuerApi(): { scopes: string[] } {
  anmeldeAnfrage ??= { scopes: [pflichtwert('VITE_ENTRA_API_SCOPE')] };
  return anmeldeAnfrage;
}
